import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a5b401fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal__head" }
const _hoisted_2 = {
  key: 0,
  class: "ellipsis headline-3",
  "data-test-id": "modal-title"
}
const _hoisted_3 = { key: 0 }

import BaseButton from '@/components/BaseButton.vue'
import { computed, PropType, useSlots } from 'vue'
import { FORMATS, SIZES } from '@/enums/components'
import InfoHelper from './InfoHelper.vue'
import { useBreakpoints } from '@/composables/useBreakpoints'


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalWrapper',
  props: {
  title: {
    type: String,
    default: null,
  },
  modalSize: {
    type: String as PropType<SIZES>,
    default: undefined,
  },
  outsideClick: {
    type: Boolean,
    default: false,
  },
},
  emits: ['close'],
  setup(__props, { emit: emits }) {

const props = __props





const slots = useSlots()
const { isMobile } = useBreakpoints()
const showCustomHeader = computed(() => {
  return !!slots?.header
})
const modalContainerClasses = computed(() => {
  let classes = ''
  if (props.modalSize) {
    classes += `modal__container--${props.modalSize} `
  }
  return classes
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "modal",
    onClick: _cache[2] || (_cache[2] = ($event: any) => (__props.outsideClick && emits('close')))
  }, [
    _createElementVNode("div", {
      id: "modalContainer",
      class: _normalizeClass(["modal__container", _unref(modalContainerClasses)]),
      onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(BaseButton, {
          format: _unref(FORMATS).ICON_CIRCULAR,
          icon: "close",
          "icon-size": 24,
          size: _unref(SIZES).MEDIUM,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('close')))
        }, null, 8, ["format", "size"]),
        (!_unref(showCustomHeader))
          ? (_openBlock(), _createElementBlock("h3", _hoisted_2, [
              _renderSlot(_ctx.$slots, "title", { title: __props.title }, () => [
                (__props.title)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(__props.title), 1))
                  : _createCommentVNode("", true),
                (_ctx.$slots.titleInfo)
                  ? (_openBlock(), _createBlock(InfoHelper, {
                      key: 1,
                      "icon-size": _unref(isMobile) ? 24 : 32
                    }, {
                      default: _withCtx(() => [
                        _renderSlot(_ctx.$slots, "titleInfo")
                      ]),
                      _: 3
                    }, 8, ["icon-size"]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _renderSlot(_ctx.$slots, "header", { key: 1 })
      ]),
      _renderSlot(_ctx.$slots, "content")
    ], 2)
  ]))
}
}

})